import * as preact from "preact";
import { DataControl, IDataControlProps } from "../DataControl/DataControl";
import { TextBox } from "../TextBox/TextBox";
import { ValueList } from "../ValueList/ValueList";


export interface IMultiTextBoxProps extends IDataControlProps
{
    Descriptor?: string;
    DescriptorTop?: string;
    TextBoxWidth?: string;
}

export class MultiTextBox extends DataControl<IMultiTextBoxProps>
{
    private _txtBox: TextBox;
    private _valueList: ValueList<string>;

    constructor(props: IDataControlProps)
    {
        super(props);
    }

    public setValue(values: string[])
    {
        this._txtBox.setValue(null);
        this._valueList.setValue(values);
    }

    public getValue(): string[]
    {
        return this._valueList.getIds();
    }

    public override getValueRaw()
    {
        return this.getValue();
    }

    public focus()
    {
        this._txtBox.focus();
    }

    private _onAddClick()
    {
        this._addValueFromBox();
    }

    private _onKeyDown(textBox: TextBox, evt: KeyboardEvent)
    {
        var key = evt.key;

        if (key === "Enter")
        {
            this._addValueFromBox();
        }
    }

    private _addValueFromBox(): void
    {
        let val = this._txtBox.getValue().trim();
        if (val)
        {
            this._valueList.addValue(val);
        }

        this._txtBox.setValue(null);
    }

    public render(props: IMultiTextBoxProps)
    {
        return (
            <span class="autogroupContainer" ref={(ref) => this._registerContainer(ref)}  >
                <TextBox
                    ActionImage="../../Images/add.png"
                    Descriptor={this.props.Descriptor}
                    DescriptorTop={this.props.DescriptorTop}
                    onActionClick={this._onAddClick.bind(this)}
                    onKeyDown={this._onKeyDown.bind(this)}
                    ref={(ref) => this._txtBox = ref}
                    style={{ minWidth: props.TextBoxWidth || "180px", verticalAlign: "top" }} />
                <ValueList style={{marginLeft: "5px"}} ref={(ref) => this._valueList = ref} />
            </span>
        );
    }
}